import { COUPON_TYPE } from 'src/app/product-capture/model/enums/coupon-type.enum';
import { ProductTypeEnum } from 'src/app/product-capture/model/enums/product-capture.enums';
import {
  PAYOFF_CALLABILITY_AMOUNT,
  PAYOFF_CALLABILITY_AMOUNT_TYPE,
  PAYOFF_CALLABILITY_CALL_EVENT_TYPE,
  PAYOFF_COUPON_CONVERSION,
  PAYOFF_COUPON_FREQUENCY,
  PAYOFF_COUPON_TYPE,
  PAYOFF_PARTICIPATION,
  PAYOFF_PARTICIPATION_BASE_TYPE,
  PAYOFF_PARTICIPATION_CAPITAL_BASE,
  PAYOFF_PARTICIPATION_DOWNSIDE_TYPE,
  PAYOFF_PARTICIPATION_UPSIDE_TYPE,
  SUMMARY_FREQUENCY,
  SUMMARY_PERFORMANCE_TYPE,
  SUMMARY_REFERENCE_ENTITIES,
  SUMMARY_SETTLEMENT_TYPE,
  SUMMARY_UNDERLYING_ASSETS_GROUP,
} from '../../mockups/consts/product-capture-field-selectors.consts';
import { DEFAULT_AND_HIDE_CAPITAL_BASE_VALUES } from './cln.settings';

export const FIXED_TO_FLOATING_FLOATING_TO_FIXED_RATE_NOTE_SETTINGS = {
  id: ProductTypeEnum.FIXED_TO_FLOATING_FLOATING_TO_FIXED_RATE_NOTE,
  label: 'Fixed to Floating/Floating to Fixed Rate Note',
  effects: [
    {
      formControlNames: [PAYOFF_COUPON_TYPE],
      selectValues: [COUPON_TYPE.FIXED_TO_FLOATING],
      readOnly: false,
      hidden: false
    },
    {
      formControlNames: [
        PAYOFF_PARTICIPATION_UPSIDE_TYPE,
        PAYOFF_PARTICIPATION_BASE_TYPE,
        PAYOFF_PARTICIPATION_DOWNSIDE_TYPE,
      ],
      selectValues: ['NONE'],
      readOnly: false,
    },
    {
      formControlNames: [
        SUMMARY_UNDERLYING_ASSETS_GROUP,
        SUMMARY_REFERENCE_ENTITIES,
        PAYOFF_COUPON_CONVERSION,
        PAYOFF_PARTICIPATION,
        PAYOFF_PARTICIPATION_BASE_TYPE,
      ],
      hidden: true,
    },
    ...DEFAULT_AND_HIDE_CAPITAL_BASE_VALUES,
    {
      formControlNames: [PAYOFF_CALLABILITY_CALL_EVENT_TYPE],
      selectValues: ['NONE'],
      hidden: false,
    },
    {
      formControlNames: [PAYOFF_CALLABILITY_AMOUNT_TYPE],
      selectValues: [null],
      readOnly: false,
    },
    {
      formControlNames: [PAYOFF_CALLABILITY_AMOUNT],
      selectValues: [null],
      readOnly: false,
    },
    {
      formControlNames: [SUMMARY_FREQUENCY],
      readOnly: false,
    },
    {
      formControlNames: [SUMMARY_PERFORMANCE_TYPE],
      selectValues: [null],
      readOnly: true,
    },
    {
      formControlNames: [SUMMARY_SETTLEMENT_TYPE],
      selectValues: ['CASH'],
      readOnly: true,
    },
    {
      formControlNames: [PAYOFF_COUPON_FREQUENCY],
      readOnly: false,
    },
    {
      formControlNames: [PAYOFF_PARTICIPATION_CAPITAL_BASE],
      hidden: true,
    },
  ],
};
